import { useEffect, useState } from "react";
import {
  calculateRiskScore,
  getColorProbability,
  getColorScore,
  getImageURLScore,
} from "../../../utils/utils";

export const EvaluationScore = ({
  data,
  score,
  probability,
  decisao = null,
  showSuggestion = true,
}) => {
  const [riskScore, setRiskScore] = useState(0);

  useEffect(() => {
    const pendencias =
      +data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal || 0;
    const protestos = +data?.resumoConsulta?.protestos?.quantidadeTotal || 0;

    setRiskScore(
      calculateRiskScore(pendencias, protestos, +score, +probability)
    );
  }, [data]);

  return (
    <div className="space-y-6">
      {/* Score e Probabilidade */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Score de Crédito */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6 flex flex-col items-center">
          <h3 className="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wide">
            Score de Crédito
          </h3>
          <img
            src={getImageURLScore(score)}
            alt="Indicador de Score"
            className="h-24 mb-4"
          />
          <div
            className="text-white font-bold text-lg px-5 py-2 rounded-full shadow"
            style={{ backgroundColor: getColorScore(score || 0) }}
          >
            Score {score}
          </div>
        </div>

        {/* Probabilidade de Inadimplência - sem gráfico */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-6">
          <h3 className="text-sm font-semibold text-gray-700 mb-4 uppercase tracking-wide">
            Probabilidade de Inadimplência
          </h3>
          <div className="flex flex-col items-center justify-center gap-4 mt-6">
            <div
              className="w-full h-6 rounded-full bg-gray-200 overflow-hidden"
              title={`${probability}%`}
            >
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{
                  width: `${probability}%`,
                  backgroundColor: getColorProbability(probability / 100),
                }}
              ></div>
            </div>
            <div className="text-lg font-semibold text-gray-800">
              {probability}% de inadimplência
            </div>
          </div>
        </div>
      </div>

      {/* Aviso Legal */}
      <div className="border border-gray-300 bg-gray-50 text-xs text-gray-700 p-4 rounded-lg leading-relaxed">
        <span className="font-semibold block mb-1">Importante:</span>A decisão
        de aprovação ou não do crédito é de exclusiva responsabilidade do
        concedente. As informações prestadas pelos provedores têm como objetivo
        subsidiar essas decisões e não devem ser utilizadas como justificativa
        exclusiva para a concessão ou recusa de crédito.
      </div>
    </div>
  );
};
